export default __webpack_public_path__ + "static/rprts-using-reports-823af6da64643d2d94a648b8fc58a5c7.mp4";